<template>
  <div class="hour-trading-metric">
    <span v-for="m in metrics" :key="m.key">
      <span>{{ m.name }}:</span>
      <span class="number">{{ m.value }}</span>
    </span>
  </div>
</template>
<script>
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
export default {
  name: 'HourTradingMetric',
  props: ['data'],
  computed: {
    metrics() {
      const floatNum = this.$options.filters.floatNum
      const { high, low, volume } = this.data || {}
      const stock = { market: MARKET_TYPE.US, secType: SEC_TYPE.STK }
      return [
        {
          name: this.$t('quote.high'),
          key: 'high',
          value: floatNum(high, stock)
        },
        {
          name: this.$t('quote.low'),
          key: 'low',
          value: floatNum(low, stock)
        },
        {
          name: this.$t('quote.volume'),
          key: 'vol',
          value: floatNum(volume, stock)
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.hour-trading-metric {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  height: 16px;
  line-height: 16px;
  color: var(--sub-text-color);
  .number {
    color: var(--default-font-color);
  }
}
</style>
